var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"cast container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('cast-live')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }